import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	selectedCron: null,

	page: 1,
	perPage: 10,
	totalItems: 0,
	totalPage: 0,
	loading: false,
	loadingDetails: false,

	modelLoading: false,
};

const cronSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setCronLoading: (state, action) => {
			state.loading = action.payload;
		},
		setCronData: (state, action) => {
			const { data, totalItems, page, perPage } = action.payload;
			state.data = data || [];
			state.totalItems = totalItems || 0;
			state.page = page || 1;
			state.perPage = perPage || 10;
			state.totalPage = Math.ceil(totalItems / perPage);
			state.loading = false;
		},
		setModelsTransactionsLoading: (state, action) => {
			state.modelLoading = action.payload;
		},
		setModelsTransactionsData: (state, action) => {
			const { models, transactions } = action.payload; // Destructure models and transactions
			state.models = models || [];
			state.transactions = transactions || [];
			state.modelLoading = false;
		},
		setSelectedCron: (state, action) => {
			state.selectedCron = action.payload;
		},
		setDetailsLoading: (state, action) => {
			state.loadingDetails = action.payload;
		},
	},
});

export const {
	setCronLoading,
	setCronData,
	setModelsTransactionsLoading,
	setModelsTransactionsData,
	setSelectedCron,
	setDetailsLoading,
} = cronSlice.actions;
export default cronSlice.reducer;
